module.exports = __webpack_public_path__ + "static/media/pediatria-2020-warszawa.dfdac55f.png";